import React, { useEffect, useState } from 'react'
import { Typography } from 'antd'
import { Order } from '../../../../../models/order/order'
import OrderHelper from '../../../../../helpers/OrderHelper'

const TICK_INTERVAL_MS = 60 * 1000

const TimeElapsedCell = ({ order }: { order: Order }) => {
  const [, forceTick] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => forceTick((tick) => tick + 1), TICK_INTERVAL_MS)
    return () => clearInterval(interval)
  }, [])

  return <Typography.Text>{OrderHelper.timeSinceOrderCreation(order)}</Typography.Text>
}

export const TimeElapsedColumn = () => {
  return {
    title: 'Created',
    dataIndex: 'createdAt',
    className: 'table-column time-elapsed-column',
    render: (_: string, order: Order) => <TimeElapsedCell order={order} />
  }
}
